import LocationSelector from './locationSelector';

export default LocationSelector;